import { Component, h } from '@stencil/core';

@Component({
  tag: 'ci-solutions',
  styleUrl: 'ci-solutions.scss',
  shadow: true,
})
export class ciSolutions {
  render() {
    const click_section = "solutions";
    return (
      <div class="ciSolutions">
        <section class="ciSolutions-columns">
          <div class="ciSolutions-column ciSolutions-column1">
            <a href={`${process.env.CI_HOSTNAME}/ink/group-order-form`}
            class="ciSolutions-link js-ciHeader-track"
            data-section={click_section}
            data-link="Group Order">
              <span class="ciSolutions-icon">
                <svg version="1.1" id="ci-group-ordering-Layer_1" x="0px" y="0px"
                  viewBox="0 0 24 24" enable-background="new 0 0 24 24">
                  <g id="ci-group-ordering-users-01">
                    <path id="ci-group-ordering-Icon__x28_Stroke_x29_" fill-rule="evenodd" clip-rule="evenodd" d="M9.5,4c-1.7,0-3,1.3-3,3s1.3,3,3,3c1.7,0,3-1.3,3-3
                      S11.2,4,9.5,4z M4.5,7c0-2.8,2.2-5,5-5c2.8,0,5,2.2,5,5s-2.2,5-5,5C6.7,12,4.5,9.8,4.5,7z M14.6,2.9c0.2-0.5,0.8-0.8,1.3-0.6
                      C17.7,3.1,19,4.9,19,7s-1.3,3.9-3.1,4.6c-0.5,0.2-1.1,0-1.3-0.6c-0.2-0.5,0-1.1,0.6-1.3C16.2,9.3,17,8.3,17,7s-0.8-2.3-1.9-2.8
                      C14.6,4,14.4,3.4,14.6,2.9z M8,14H11c0.9,0,1.6,0,2.2,0c0.6,0,1.1,0.1,1.7,0.3c1.2,0.5,2.2,1.5,2.7,2.7c0.2,0.5,0.3,1,0.3,1.7
                      c0,0.6,0,1.3,0,2.2v0c0,0.6-0.4,1-1,1s-1-0.4-1-1c0-0.9,0-1.6,0-2.1c0-0.5-0.1-0.8-0.2-1c-0.3-0.7-0.9-1.3-1.6-1.6
                      c-0.2-0.1-0.5-0.2-1-0.2c-0.5,0-1.2,0-2.1,0H8c-0.9,0-1.6,0-2.1,0c-0.5,0-0.8,0.1-1,0.2c-0.7,0.3-1.3,0.9-1.6,1.6
                      c-0.1,0.2-0.2,0.5-0.2,1c0,0.5,0,1.2,0,2.1c0,0.6-0.4,1-1,1c-0.6,0-1-0.4-1-1v0c0-0.9,0-1.6,0-2.2c0-0.6,0.1-1.1,0.3-1.7
                      c0.5-1.2,1.5-2.2,2.7-2.7c0.5-0.2,1-0.3,1.7-0.3C6.3,14,7.1,14,8,14z M18,14.9c0.1-0.5,0.7-0.9,1.2-0.7c2.2,0.6,3.8,2.5,3.8,4.8v2
                      c0,0.6-0.4,1-1,1s-1-0.4-1-1v-2c0-1.4-1-2.6-2.2-2.9C18.2,16,17.9,15.4,18,14.9z"/>
                  </g>
                </svg>
              </span>
              <span class="ciSolutions-text">
                <span class="ciSolutions-title">
                  Group Ordering
                </span>
                <span class="ciSolutions-subtitle">
                  Easily collect sizes, addresses, and payments from your group.
                </span>
              </span>
            </a>
            <a href={`${process.env.CI_HOSTNAME}/fundraising`}
            class="ciSolutions-link js-ciHeader-track"
            data-section={click_section}
            data-link="Fundraising">
              <span class="ciSolutions-icon">
                <svg version="1.1" id="ci-fundraising-Layer_1" x="0px" y="0px"
                  viewBox="0 0 24 24" enable-background="new 0 0 24 24">
                  <g id="ci-fundraising-heart-hand">
                    <path id="ci-fundraising-Icon__x28_Stroke_x29_" fill-rule="evenodd" clip-rule="evenodd" d="M17.5,2.3c-1-1.1-2.5-1.6-4.1-0.9
                      c-1.8,0.9-2.6,2.9-1.8,4.8C12,7.1,13,8.8,13.7,9.9c0,0,0,0,0,0c0.1,0.2,0.2,0.4,0.3,0.5c0.1,0.2,0.3,0.4,0.5,0.5
                      c0.3,0.2,0.7,0.3,1.1,0.3c0.3,0,0.5-0.1,0.7-0.2c0.2-0.1,0.4-0.2,0.6-0.3l0,0c1.1-0.6,2.9-1.5,3.7-2.1c1.6-1.2,2-3.4,0.8-5.1
                      C20.5,2.2,18.9,1.8,17.5,2.3z M16.3,4c-0.4-0.8-1.2-1.2-2-0.8c-0.9,0.4-1.2,1.4-0.9,2.2c0.3,0.7,1.2,2.2,2,3.4
                      c0.1,0.2,0.2,0.3,0.3,0.4c0,0,0,0,0,0c0,0,0,0,0,0c0.1,0,0.2-0.1,0.4-0.2c1.2-0.6,2.8-1.5,3.4-1.9c0.7-0.6,0.9-1.5,0.4-2.3
                      c-0.5-0.7-1.4-0.8-2.1-0.3c-0.2,0.2-0.5,0.2-0.8,0.1C16.7,4.5,16.4,4.3,16.3,4z M3.6,12h0.9c0.3,0,0.5,0,0.7,0
                      c0.2,0,0.5,0.1,0.8,0.2c0.4,0.2,0.7,0.5,0.9,0.9c0.1,0.2,0.1,0.3,0.2,0.5l1.6-0.7l0,0c0,0,0,0,0.1,0c0.1,0,0.1-0.1,0.2-0.1
                      c0.2-0.1,0.5-0.2,0.8-0.3c0.6-0.2,1.4-0.5,2.1-0.5c0.5,0,1,0.1,1.4,0.2l2.4,0.6c1.1,0.3,1.9,1.2,2,2.3l1.5-1.1
                      c1-0.7,2.4-0.6,3.3,0.2c1,1,1,2.6,0,3.6l-2.2,2.1c-0.7,0.7-1.6,1.2-2.6,1.4l-3,0.6c-0.7,0.1-1.5,0.1-2.3-0.1l-2.8-0.7l0,0
                      c-0.3-0.1-0.5-0.1-0.8-0.1H7c0,0,0,0,0,0.1c0,0.2-0.1,0.5-0.2,0.8c-0.2,0.4-0.5,0.7-0.9,0.9C5.6,22.9,5.4,23,5.1,23
                      c-0.2,0-0.5,0-0.7,0H3.6c-0.3,0-0.5,0-0.7,0c-0.2,0-0.5-0.1-0.8-0.2c-0.4-0.2-0.7-0.5-0.9-0.9C1.1,21.6,1,21.4,1,21.1
                      c0-0.2,0-0.5,0-0.7v-5.9c0-0.3,0-0.5,0-0.7c0-0.2,0.1-0.5,0.2-0.8c0.2-0.4,0.5-0.7,0.9-0.9C2.4,12.1,2.6,12,2.9,12
                      C3.1,12,3.3,12,3.6,12z M7,19.1h1.6c0.4,0,0.8,0,1.2,0.2c0,0,0,0,0,0l2.8,0.7c0.5,0.1,0.9,0.1,1.4,0 M14,19.9l3-0.6c0,0,0,0,0,0
                      c0.6-0.1,1.2-0.4,1.6-0.8l2.2-2.1c0.2-0.2,0.2-0.5,0-0.7c-0.2-0.2-0.5-0.2-0.8-0.1l-2.5,1.8C17,17.8,16.4,18,15.7,18h-2.4
                      c-0.6,0-1-0.4-1-1c0-0.6,0.4-1,1-1h1.5c0.3,0,0.6-0.3,0.6-0.5v-0.3c0-0.2-0.2-0.5-0.4-0.5l-2.4-0.6C12.3,14,12,14,11.6,14
                      c-0.3,0-0.8,0.1-1.4,0.3c-0.3,0.1-0.5,0.2-0.7,0.3c-0.1,0-0.1,0.1-0.2,0.1l-0.1,0l0,0l0,0c0,0,0,0,0,0l-2.3,1v3.4 M5,15v5.4
                      c0,0.3,0,0.5,0,0.6c0,0,0,0,0,0c0,0,0,0,0,0c-0.1,0-0.3,0-0.6,0H3.6c-0.3,0-0.5,0-0.6,0c0,0,0,0,0,0c0,0,0,0,0,0c0-0.1,0-0.3,0-0.6
                      v-5.8c0-0.3,0-0.5,0-0.6c0,0,0,0,0,0c0,0,0,0,0,0c0.1,0,0.3,0,0.6,0h0.8c0.3,0,0.5,0,0.6,0c0,0,0,0,0,0c0,0,0,0,0,0
                      c0,0.1,0,0.3,0,0.6V15C5,15,5,15,5,15z"/>
                  </g>
                </svg>
              </span>
              <span class="ciSolutions-text">
                <span class="ciSolutions-title">
                  Fundraising
                </span>
                <span class="ciSolutions-subtitle">
                  Raise money and awareness for anything you care about.
                </span>
              </span>
            </a>
          </div>
          <div class="ciSolutions-column ciSolutions-column2">
            <a
              href={`${process.env.CI_HOSTNAME}/onlinestores`}
              class="ciSolutions-link js-ciHeader-track"
              data-section={click_section}
              data-link="Online Stores">
              <span class="ciSolutions-icon">
                <svg version="1.1" id="ci_onlinestores" x="0px" y="0px"
                  viewBox="0 0 24 24" enable-background="new 0 0 24 24">
                  <g id="ci_onlinestores-building-02">
                    <path id="ci_onlinestores-Icon__x28_Stroke_x29_" fill-rule="evenodd" clip-rule="evenodd" d="M6.2,2h11.7c0.5,0,1,0,1.4,0c0.4,0,0.8,0.1,1.2,0.3
                      c0.6,0.3,1,0.7,1.3,1.3C21.9,4,21.9,4.4,22,4.8c0,0.4,0,0.8,0,1.4v11.7c0,0.5,0,1,0,1.4c0,0.4-0.1,0.8-0.3,1.2
                      c-0.3,0.6-0.7,1-1.3,1.3c-0.4,0.2-0.8,0.3-1.2,0.3c-0.4,0-0.8,0-1.4,0H6.2c-0.5,0-1,0-1.4,0c-0.4,0-0.8-0.1-1.2-0.3
                      c-0.6-0.3-1-0.7-1.3-1.3C2.1,20,2.1,19.6,2,19.2c0-0.4,0-0.8,0-1.4V6.2c0-0.5,0-1,0-1.4c0-0.4,0.1-0.8,0.3-1.2
                      c0.3-0.6,0.7-1,1.3-1.3C4,2.1,4.4,2.1,4.8,2C5.2,2,5.6,2,6.2,2z M4,10.5v7.3c0,0.6,0,0.9,0,1.2c0,0.3,0.1,0.4,0.1,0.4
                      c0.1,0.2,0.2,0.3,0.4,0.4c0,0,0.2,0.1,0.4,0.1c0.3,0,0.7,0,1.2,0H8v-4.4c0-0.3,0-0.5,0-0.7c0-0.2,0.1-0.5,0.2-0.8
                      c0.2-0.4,0.5-0.7,0.9-0.9C9.4,13.1,9.6,13,9.9,13c0.2,0,0.5,0,0.7,0h2.9c0.3,0,0.5,0,0.7,0c0.2,0,0.5,0.1,0.8,0.2
                      c0.4,0.2,0.7,0.5,0.9,0.9c0.1,0.3,0.2,0.5,0.2,0.8c0,0.2,0,0.5,0,0.7V20h1.8c0.6,0,0.9,0,1.2,0c0.3,0,0.4-0.1,0.4-0.1
                      c0.2-0.1,0.3-0.2,0.4-0.4c0,0,0.1-0.2,0.1-0.4c0-0.3,0-0.7,0-1.2v-7.3c-0.6,0.3-1.3,0.5-2,0.5c-1.2,0-2.3-0.5-3-1.4
                      c-0.7,0.8-1.8,1.4-3,1.4s-2.3-0.5-3-1.4C8.3,10.5,7.2,11,6,11C5.3,11,4.6,10.8,4,10.5z M10,7c0,1.1,0.9,2,2,2s2-0.9,2-2
                      c0-0.6,0.4-1,1-1s1,0.4,1,1c0,1.1,0.9,2,2,2s2-0.9,2-2V6.2c0-0.6,0-0.9,0-1.2c0-0.3-0.1-0.4-0.1-0.4c-0.1-0.2-0.2-0.3-0.4-0.4
                      c0,0-0.2-0.1-0.4-0.1c-0.3,0-0.7,0-1.2,0H6.2C5.6,4,5.3,4,5,4C4.7,4,4.6,4.1,4.5,4.1C4.4,4.2,4.2,4.4,4.1,4.5C4.1,4.6,4,4.7,4,5
                      c0,0.3,0,0.7,0,1.2V7c0,1.1,0.9,2,2,2s2-0.9,2-2c0-0.6,0.4-1,1-1C9.6,6,10,6.4,10,7z M14,20v-4.4c0-0.3,0-0.5,0-0.6c0,0,0,0,0,0
                      c0,0,0,0,0,0c-0.1,0-0.3,0-0.6,0h-2.8c-0.3,0-0.5,0-0.6,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0.1,0,0.3,0,0.6V20H14z"/>
                  </g>
                </svg>
              </span>
              <span class="ciSolutions-text">
                <span class="ciSolutions-title">
                  Online Stores
                </span>
                <span class="ciSolutions-subtitle">
                  Create a branded storefront to sell merchandise to your community.
                </span>
              </span>
            </a>
          </div>
        </section>
      </div>
    );
  }
}
